import { createSlice } from '@reduxjs/toolkit';
const InitialState = {
    taskDetail: {},
    scrollToAttachments: null,
};
const readMailSlice = createSlice({
    name: 'readMailReducer',
    initialState: InitialState,
    reducers: {
        updateTaskDetail: (state, action) => {
            state.taskDetail = action.payload;
        },
        updateScrollToAttachments: (state, action) => {
            state.scrollToAttachments = {
                mailId: action.payload,
            };
        },
    },
});
export const { actions } = readMailSlice;
export default readMailSlice.reducer;
